import FaqList from 'components/blog/Faq'

export default function Faq() {
  return (
    <section className="relative bg-white bg-center overflow-hidden font-['Inter']">
      <div className="bg-transparent">
        <div className="relative pt-16 pb-12">
          <div className="container px-4 md:px-0 mx-auto max-w-3xl lg:max-w-5xl">
            <div className="relative flex flex-wrap justify-center -mx-4">
              <div className="w-full px-4 mb-12 md:mb-0 text-center">
                <h1 className="main-top-title mb-16">
                  Frequently Asked Questions
                </h1>
                <div className="w-full px-10 text-left">
                  <FaqList faqName="ckan-consultancy" variant="page" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
